var map = {
	"./f-blonde.svg": "200e",
	"./f-blue.svg": "5fb4",
	"./f-pink.svg": "ca45",
	"./f-red.svg": "4e2e",
	"./f-yellow.svg": "0cc8",
	"./horse.svg": "d7c0",
	"./house-blue.svg": "98f1",
	"./house-red.svg": "69d3",
	"./m-black.svg": "7a07",
	"./m-blue.svg": "54d0",
	"./m-capblue.svg": "f384",
	"./m-monocle.svg": "2583",
	"./m-pink.svg": "4374",
	"./m-suitblack.svg": "e722",
	"./m-suitblue.svg": "d584",
	"./m-suitpink.svg": "d8e7",
	"./m-suitred.svg": "2cf2",
	"./stembus.svg": "9329",
	"./tower.svg": "6c73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59df";